export default "__VITE_ASSET__DcfKC3iP__"